var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g, _path23, _g2, _path24, _g3, _path25, _g4, _path26, _g5, _path27, _g6, _path28, _g7, _path29, _g8, _path30, _g9, _path31, _g10, _path32, _g11, _path33, _g12, _path34, _g13, _path35, _g14, _path36, _g15, _path37, _g16, _path38, _g17, _path39, _g18, _path40, _g19, _path41, _g20, _path42, _g21, _path43, _g22, _path44, _g23, _path45, _g24, _path46, _g25, _path47, _g26, _path48, _g27, _path49, _g28, _path50, _g29, _path51, _g30, _path52, _g31, _path53, _g32, _path54, _g33, _path55, _g34, _path56, _g35, _path57, _g36, _path58, _path59, _path60, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 50,
    viewBox: "0 0 98 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_541)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4043 48.8479H1.13504V45.8271H4.17145C4.24132 45.829 4.3108 45.8161 4.3754 45.7894C4.43999 45.7627 4.49827 45.7228 4.54647 45.6722C4.64065 45.574 4.69203 45.4425 4.68933 45.3065C4.69042 45.2384 4.67719 45.1708 4.65049 45.1082C4.62379 45.0455 4.58418 44.9892 4.53431 44.9429C4.436 44.8489 4.30459 44.7975 4.16862 44.8H1.13504V42.0722H4.33145C4.46744 42.0747 4.59892 42.0233 4.69718 41.9293C4.74713 41.883 4.78675 41.8267 4.81345 41.764C4.84016 41.7014 4.85335 41.6338 4.85217 41.5657C4.8516 41.4278 4.79659 41.2957 4.69906 41.1982C4.60153 41.1006 4.46938 41.0456 4.33145 41.045H0.749297C0.659478 41.0435 0.570307 41.06 0.48702 41.0937C0.403733 41.1273 0.328068 41.1774 0.264547 41.2409C0.201026 41.3045 0.150939 41.3801 0.117278 41.4634C0.0836166 41.5467 0.0670333 41.6359 0.0685806 41.7257V49.1972C0.0671328 49.287 0.0837558 49.3761 0.117452 49.4593C0.151149 49.5426 0.201264 49.6182 0.264765 49.6817C0.328266 49.7452 0.403865 49.7953 0.487107 49.829C0.57035 49.8627 0.659505 49.8793 0.749297 49.8779H4.4043C4.54223 49.8773 4.67438 49.8223 4.77191 49.7247C4.86944 49.6272 4.92445 49.4951 4.92502 49.3572C4.92614 49.2892 4.91292 49.2217 4.88622 49.1592C4.85951 49.0967 4.81992 49.0405 4.77003 48.9943C4.67164 48.9 4.53985 48.8486 4.4036 48.8514",
    fill: "#003155"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1294 41.0743C10.08 41.1217 10.0409 41.1788 10.0145 41.2419C9.98809 41.3051 9.97493 41.373 9.97583 41.4414V43.6879C9.79938 43.6044 9.61607 43.5363 9.42795 43.4843C9.17846 43.416 8.92094 43.3816 8.66227 43.3821C8.34861 43.3674 8.03524 43.4168 7.74134 43.5273C7.44743 43.6379 7.17917 43.8072 6.95298 44.025C6.73803 44.2538 6.57123 44.5234 6.46252 44.8179C6.3538 45.1124 6.30535 45.4257 6.32009 45.7393V47.6414C6.31624 47.9671 6.37293 48.2907 6.48724 48.5957C6.59338 48.8741 6.75666 49.1271 6.96654 49.3386C7.17834 49.5485 7.4306 49.7133 7.70798 49.8229C8.01223 49.9414 8.33645 50.0004 8.66297 49.9964C8.98898 49.9971 9.31446 49.9699 9.63582 49.915C9.94835 49.8612 10.2564 49.7838 10.5572 49.6836C10.6891 49.6368 10.804 49.5517 10.8873 49.4393C10.9731 49.3261 11.0191 49.1877 11.018 49.0457V41.4414C11.019 41.373 11.0059 41.3052 10.9796 41.242C10.9533 41.1789 10.9144 41.1218 10.8651 41.0743C10.8169 41.026 10.7596 40.9877 10.6965 40.9615C10.6335 40.9354 10.5659 40.9219 10.4976 40.9219C10.4293 40.9219 10.3617 40.9354 10.2987 40.9615C10.2356 40.9877 10.1784 41.026 10.1301 41.0743M7.36226 45.6757C7.35181 45.4998 7.37639 45.3236 7.43463 45.1574C7.49288 44.9911 7.58361 44.838 7.70153 44.7071C7.82987 44.5874 7.98122 44.4951 8.14639 44.4358C8.31156 44.3765 8.4871 44.3514 8.66227 44.3621C8.91091 44.3616 9.15826 44.3975 9.39652 44.4686C9.61199 44.533 9.81022 44.645 9.97653 44.7964V48.8357C9.54917 48.958 9.10679 49.0198 8.66227 49.0193C8.4871 49.03 8.31156 49.005 8.14639 48.9457C7.98122 48.8864 7.82984 48.794 7.70153 48.6743C7.58358 48.5434 7.49284 48.3904 7.43459 48.2241C7.37634 48.0578 7.35177 47.8816 7.36226 47.7057V45.6757Z",
    fill: "#003155"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0693 48.8372C15.6464 48.9587 15.2086 49.0206 14.7686 49.0207C14.5917 49.0383 14.4131 49.0164 14.2457 48.9566C14.0784 48.8968 13.9263 48.8006 13.8006 48.675C13.6749 48.5493 13.5786 48.3973 13.5187 48.23C13.4588 48.0626 13.4368 47.884 13.4543 47.7072V43.9043C13.4552 43.8359 13.4422 43.768 13.4161 43.7047C13.3899 43.6415 13.3512 43.5842 13.3022 43.5364C13.2539 43.4881 13.1967 43.4498 13.1336 43.4237C13.0705 43.3975 13.0029 43.384 12.9347 43.384C12.8664 43.384 12.7988 43.3975 12.7357 43.4237C12.6727 43.4498 12.6154 43.4881 12.5671 43.5364C12.5177 43.584 12.4786 43.6411 12.4521 43.7044C12.4257 43.7677 12.4126 43.8357 12.4136 43.9043V47.6457C12.389 47.9615 12.4331 48.2789 12.5429 48.5761C12.6527 48.8732 12.8255 49.143 13.0494 49.367C13.2734 49.591 13.5433 49.7638 13.8404 49.8736C14.1376 49.9833 14.4549 50.0275 14.7707 50.0029C15.0941 50.0029 15.4169 49.9757 15.7357 49.9214C16.0507 49.8677 16.3611 49.7902 16.6643 49.6893C16.7961 49.6428 16.9102 49.5563 16.9907 49.4421C17.0712 49.3278 17.1142 49.1913 17.1136 49.0515V43.9086C17.1146 43.84 17.1015 43.772 17.0751 43.7087C17.0486 43.6454 17.0095 43.5882 16.96 43.5407C16.9118 43.4924 16.8545 43.4541 16.7914 43.4279C16.7284 43.4018 16.6608 43.3883 16.5925 43.3883C16.5243 43.3883 16.4567 43.4018 16.3936 43.4279C16.3305 43.4541 16.2733 43.4924 16.225 43.5407",
    fill: "#003155"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2222 43.5357C16.1729 43.5833 16.1339 43.6405 16.1076 43.7038C16.0813 43.7671 16.0683 43.8351 16.0694 43.9036V48.8365",
    fill: "#003155"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9308 44.7086C20.0606 44.5889 20.2132 44.4966 20.3795 44.4372C20.5458 44.3778 20.7224 44.3525 20.8987 44.3629C21.1038 44.3631 21.308 44.3907 21.5058 44.445C21.7113 44.5019 21.9108 44.5787 22.1015 44.6743C22.1984 44.716 22.3051 44.7295 22.4093 44.7133C22.5135 44.6971 22.6111 44.6519 22.6908 44.5829C22.7412 44.5382 22.7812 44.4832 22.8082 44.4215C22.8353 44.3598 22.8486 44.293 22.8472 44.2257C22.8486 44.1288 22.8217 44.0337 22.77 43.9517C22.7183 43.8698 22.6439 43.8047 22.5558 43.7643C22.0395 43.5135 21.4727 43.3838 20.8987 43.385C20.5706 43.3816 20.2448 43.4405 19.9387 43.5586C19.6587 43.6672 19.4039 43.832 19.1901 44.0429C18.9804 44.2543 18.8173 44.5074 18.7115 44.7857C18.5972 45.0907 18.5405 45.4143 18.5444 45.74V47.6479C18.5406 47.9736 18.5973 48.2971 18.7115 48.6022C18.8171 48.8807 18.9801 49.1338 19.1901 49.345C19.4038 49.556 19.6586 49.7208 19.9387 49.8293C20.2449 49.9471 20.5706 50.0058 20.8987 50.0022C21.4724 50.0034 22.0389 49.8739 22.5551 49.6236C22.6447 49.5852 22.7206 49.5206 22.7728 49.4382C22.825 49.3559 22.8509 49.2596 22.8472 49.1622C22.8486 49.0948 22.8352 49.0279 22.8081 48.9663C22.7809 48.9046 22.7407 48.8496 22.6901 48.805C22.6124 48.7306 22.5131 48.6829 22.4064 48.6689C22.2998 48.6549 22.1915 48.6753 22.0972 48.7272C21.9091 48.8167 21.713 48.8884 21.5115 48.9415C21.3115 48.9958 21.1052 49.0234 20.8979 49.0236C20.7211 49.0412 20.5426 49.0193 20.3752 48.9595C20.2078 48.8997 20.0558 48.8035 19.9302 48.6778C19.8045 48.5521 19.7083 48.4001 19.6485 48.2328C19.5887 48.0654 19.5668 47.8869 19.5844 47.71V45.6793C19.5741 45.503 19.5994 45.3265 19.6588 45.1602C19.7182 44.9939 19.8105 44.8413 19.9301 44.7115",
    fill: "#003155"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2721 43.8729C28.0593 43.7062 27.817 43.5811 27.5578 43.5043C26.9704 43.3453 26.3516 43.3426 25.7628 43.4965C25.4337 43.5764 25.1199 43.7101 24.8342 43.8922C24.7551 43.9385 24.6897 44.0051 24.6448 44.0851C24.5998 44.165 24.577 44.2555 24.5785 44.3472C24.5756 44.4164 24.5884 44.4855 24.6159 44.5491C24.6435 44.6127 24.6852 44.6692 24.7378 44.7143C24.8201 44.788 24.9239 44.833 25.0339 44.8426C25.1439 44.8523 25.254 44.8261 25.3478 44.7679C25.5616 44.6403 25.7896 44.5382 26.0271 44.4636C26.2492 44.3964 26.4801 44.3624 26.7121 44.3629C27.0271 44.3472 27.3383 44.4372 27.5964 44.6186C27.7057 44.709 27.7916 44.8244 27.8468 44.9551C27.9021 45.0858 27.9249 45.2279 27.9135 45.3693V46.0429H26.6085C26.2636 46.038 25.9194 46.0783 25.585 46.1629C25.3046 46.2337 25.0452 46.3706 24.8285 46.5622C24.6364 46.7479 24.486 46.9725 24.3875 47.2209C24.289 47.4694 24.2445 47.7359 24.2571 48.0029C24.2416 48.2708 24.2851 48.5388 24.3846 48.788C24.4841 49.0372 24.6371 49.2615 24.8328 49.445C25.3364 49.8447 25.9706 50.0427 26.6121 50.0007C26.9334 50.0008 27.2541 49.9736 27.5707 49.9193C27.8833 49.865 28.1913 49.7872 28.4921 49.6864C28.6245 49.64 28.74 49.5549 28.8235 49.4422C28.9096 49.3291 28.9559 49.1907 28.955 49.0486V45.3557C28.9608 45.0576 28.898 44.7621 28.7714 44.4922C28.6543 44.2514 28.485 44.0398 28.2757 43.8729M26.6128 47.0215H27.9085V48.8365C27.4857 48.9581 27.0478 49.0198 26.6078 49.02C26.3659 49.0281 26.1244 48.9951 25.8935 48.9222C25.7457 48.8741 25.6118 48.7908 25.5035 48.6793C25.4213 48.5897 25.3635 48.4805 25.3357 48.3622C25.3097 48.2449 25.296 48.1252 25.295 48.005C25.2961 47.8865 25.3103 47.7684 25.3371 47.6529C25.3647 47.5384 25.4225 47.4333 25.5043 47.3486C25.6132 47.2408 25.7468 47.1614 25.8935 47.1172C26.1252 47.0483 26.3663 47.017 26.6078 47.0243",
    fill: "#003155"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7122 44.5107C32.8448 44.5132 32.9731 44.4635 33.0693 44.3721C33.118 44.3265 33.1565 44.2711 33.1822 44.2096C33.2079 44.148 33.2203 44.0817 33.2186 44.015C33.2198 43.9478 33.2074 43.8811 33.1822 43.8188C33.157 43.7566 33.1195 43.7 33.072 43.6525C33.0245 43.6051 32.9678 43.5677 32.9055 43.5426C32.8432 43.5175 32.7765 43.5052 32.7093 43.5064H31.3957V41.4429C31.3965 41.3745 31.3835 41.3068 31.3573 41.2437C31.3312 41.1806 31.2925 41.1235 31.2436 41.0757C31.1953 41.0274 31.138 40.989 31.0749 40.9629C31.0118 40.9367 30.9441 40.9232 30.8758 40.9232C30.8074 40.9232 30.7398 40.9367 30.6767 40.9629C30.6135 40.989 30.5562 41.0274 30.5079 41.0757C30.4587 41.1232 30.4197 41.1803 30.3934 41.2434C30.3671 41.3066 30.3541 41.3745 30.3551 41.4429V48.2129C30.3529 48.4602 30.3992 48.7055 30.4915 48.935C30.5759 49.1472 30.7003 49.3411 30.8579 49.5064C31.0127 49.6648 31.1981 49.79 31.4029 49.8743C31.6144 49.9616 31.8412 50.006 32.0701 50.005C32.1908 50.0049 32.3114 49.9987 32.4315 49.9864C32.5515 49.974 32.6705 49.9595 32.7886 49.9428C32.9136 49.9266 33.0273 49.8623 33.1057 49.7636C33.1804 49.6707 33.2208 49.5549 33.22 49.4357C33.2228 49.3654 33.209 49.2955 33.1798 49.2315C33.1507 49.1675 33.107 49.1112 33.0522 49.0671C32.9608 48.9878 32.8446 48.9428 32.7236 48.94C32.6166 48.9427 32.5098 48.9511 32.4036 48.965C32.2932 48.9792 32.1821 48.9871 32.0708 48.9886C31.9821 48.9902 31.8941 48.9734 31.8122 48.9394C31.7304 48.9053 31.6564 48.8547 31.595 48.7907C31.5262 48.7176 31.4731 48.6311 31.439 48.5366C31.405 48.4421 31.3908 48.3417 31.3972 48.2414V44.5157L32.7122 44.5107Z",
    fill: "#003155"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9122 43.5357C34.863 43.5834 34.8241 43.6407 34.7979 43.7039C34.7716 43.7672 34.7584 43.8351 34.7593 43.9036V49.4793C34.7643 49.614 34.8213 49.7415 34.9184 49.835C35.0154 49.9285 35.1449 49.9808 35.2797 49.9808C35.4145 49.9808 35.544 49.9285 35.641 49.835C35.7381 49.7415 35.7951 49.614 35.8001 49.4793V43.9036C35.8009 43.8351 35.7878 43.7672 35.7615 43.7039C35.7352 43.6407 35.6963 43.5835 35.6472 43.5357C35.5497 43.4383 35.4175 43.3836 35.2797 43.3836C35.1419 43.3836 35.0097 43.4383 34.9122 43.5357Z",
    fill: "#003155"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2801 40.9214C35.1936 40.9205 35.1078 40.9368 35.0277 40.9695C34.9476 41.0021 34.8748 41.0504 34.8136 41.1115C34.7524 41.1727 34.704 41.2454 34.6713 41.3255C34.6386 41.4056 34.6221 41.4914 34.623 41.5779C34.6218 41.665 34.6379 41.7514 34.6704 41.8322C34.7029 41.913 34.7511 41.9866 34.8123 42.0486C34.8729 42.1111 34.9455 42.1609 35.0258 42.1948C35.106 42.2288 35.1923 42.2463 35.2794 42.2463C35.3666 42.2463 35.4528 42.2288 35.5331 42.1948C35.6133 42.1609 35.6859 42.1111 35.7466 42.0486C35.8078 41.9867 35.8561 41.9131 35.8886 41.8323C35.9211 41.7515 35.9372 41.665 35.9359 41.5779C35.9368 41.4915 35.9205 41.4057 35.8879 41.3257C35.8553 41.2457 35.8071 41.173 35.746 41.1118C35.6849 41.0507 35.6122 41.0024 35.5322 40.9697C35.4522 40.937 35.3665 40.9206 35.2801 40.9214Z",
    fill: "#003155"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5894 44.0721C41.368 43.8495 41.1023 43.676 40.8094 43.5629C40.1613 43.3234 39.4489 43.3234 38.8008 43.5629C38.5081 43.6758 38.2425 43.8494 38.0215 44.0721C37.8039 44.2979 37.6339 44.5651 37.5215 44.8579C37.3995 45.1782 37.339 45.5187 37.343 45.8614V47.5229C37.339 47.8656 37.3995 48.2061 37.5215 48.5264C37.6338 48.8192 37.8039 49.0864 38.0215 49.3121C38.2425 49.535 38.5081 49.7085 38.8008 49.8214C39.449 50.0606 40.1612 50.0606 40.8094 49.8214C41.1024 49.7085 41.3681 49.5349 41.5894 49.3121C41.8067 49.0862 41.9768 48.819 42.0894 48.5264C42.2123 48.2063 42.2733 47.8657 42.2694 47.5229V45.8607C42.2733 45.5178 42.2123 45.1773 42.0894 44.8571C41.977 44.5644 41.8069 44.2973 41.5894 44.0714M41.2322 45.7986V47.5843C41.2437 47.7768 41.2168 47.9697 41.1531 48.1518C41.0895 48.3339 40.9904 48.5015 40.8615 48.645C40.564 48.8879 40.1917 49.0206 39.8076 49.0206C39.4235 49.0206 39.0512 48.8879 38.7537 48.645C38.6246 48.5017 38.5253 48.3341 38.4616 48.1519C38.398 47.9698 38.3712 47.7769 38.383 47.5843V45.7986C38.3713 45.606 38.3981 45.4131 38.4617 45.231C38.5254 45.0489 38.6246 44.8812 38.7537 44.7379C39.0512 44.4948 39.4235 44.362 39.8076 44.362C40.1917 44.362 40.5641 44.4948 40.8615 44.7379C40.9903 44.8814 41.0894 45.0491 41.153 45.2311C41.2167 45.4132 41.2436 45.6061 41.2322 45.7986Z",
    fill: "#003155"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7308 44.0407C47.5187 43.8313 47.2665 43.6668 46.9894 43.5572C46.685 43.4388 46.3609 43.3799 46.0344 43.3836C45.39 43.3775 44.7494 43.4839 44.1415 43.6979C44.0093 43.7444 43.8941 43.8295 43.8108 43.9422C43.7247 44.0552 43.6785 44.1936 43.6794 44.3357V49.4786C43.6783 49.5471 43.6913 49.6151 43.7176 49.6784C43.7439 49.7417 43.7829 49.7989 43.8322 49.8465C43.8805 49.8948 43.9379 49.9331 44.001 49.9593C44.0641 49.9854 44.1318 49.9989 44.2001 49.9989C44.2684 49.9989 44.3361 49.9854 44.3992 49.9593C44.4623 49.9331 44.5196 49.8948 44.5679 49.8465C44.6169 49.7986 44.6556 49.7414 44.6818 49.6781C44.708 49.6149 44.721 49.547 44.7201 49.4786V44.5464C45.1475 44.4243 45.5899 44.3625 46.0344 44.3629C46.2096 44.3521 46.3851 44.3771 46.5503 44.4364C46.7154 44.4957 46.8668 44.5881 46.9951 44.7079C47.1133 44.8386 47.2042 44.9916 47.2626 45.1579C47.321 45.3242 47.3456 45.5005 47.3351 45.6764V49.4793C47.3351 49.6174 47.3899 49.7498 47.4876 49.8475C47.5852 49.9452 47.7177 50 47.8558 50C47.9939 50 48.1264 49.9452 48.224 49.8475C48.3217 49.7498 48.3765 49.6174 48.3765 49.4793V45.7379C48.3803 45.4122 48.3239 45.0887 48.2101 44.7836C48.1037 44.5053 47.9405 44.2523 47.7308 44.0407Z",
    fill: "#003155"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6001 45.9771C57.4256 45.7868 57.2259 45.6212 57.0065 45.485C56.7879 45.3493 56.5594 45.2215 56.3265 45.105L54.9851 44.4529C54.7147 44.3293 54.4748 44.1479 54.2822 43.9214C54.1274 43.7146 54.048 43.461 54.0572 43.2029C54.0481 43.007 54.0908 42.8121 54.1811 42.638C54.2714 42.4639 54.4061 42.3168 54.5715 42.2114C54.7303 42.1071 54.9067 42.0325 55.0922 41.9914C55.5726 41.8894 56.0703 41.9016 56.5451 42.0272C56.8009 42.094 57.0514 42.1799 57.2944 42.2843C57.3625 42.3171 57.4373 42.3335 57.5129 42.3322C57.5813 42.3329 57.6491 42.3198 57.7122 42.2935C57.7754 42.2672 57.8325 42.2284 57.8801 42.1793C57.9286 42.1334 57.9672 42.078 57.9935 42.0166C58.0198 41.9551 58.0332 41.889 58.0329 41.8222C58.0347 41.7175 58.0056 41.6147 57.9494 41.5264C57.8892 41.4364 57.8011 41.3686 57.6986 41.3336C57.4016 41.2151 57.0969 41.1171 56.7865 41.04C56.4194 40.9548 56.0433 40.9145 55.6665 40.92C55.3221 40.9185 54.9795 40.97 54.6508 41.0729C54.3426 41.1672 54.0541 41.3168 53.7994 41.5143C53.5561 41.7071 53.3563 41.949 53.2129 42.2243C53.063 42.519 52.9873 42.8458 52.9922 43.1764C52.9876 43.4472 53.0247 43.717 53.1022 43.9764C53.1694 44.1949 53.2751 44.3995 53.4144 44.5807C53.5516 44.7566 53.7144 44.9109 53.8972 45.0386C54.096 45.1765 54.3068 45.296 54.5272 45.3957L55.8672 46.0479C56.0288 46.1286 56.1861 46.2175 56.3386 46.3143C56.4832 46.405 56.6149 46.5148 56.7301 46.6407C56.8411 46.7633 56.9329 46.902 57.0022 47.0522C57.0716 47.2071 57.1062 47.3753 57.1036 47.545C57.116 47.742 57.0865 47.9394 57.0169 48.1241C56.9473 48.3088 56.8393 48.4766 56.7001 48.6164C56.3402 48.8969 55.8884 49.0322 55.4337 48.9957C55.1391 48.9967 54.8456 48.9604 54.5601 48.8879C54.2751 48.8142 53.9977 48.714 53.7315 48.5886C53.6634 48.5557 53.5885 48.5393 53.5129 48.5407C53.4456 48.5393 53.3786 48.5512 53.3158 48.5757C53.2531 48.6002 53.1958 48.6369 53.1472 48.6836C53.0971 48.7298 53.0575 48.7861 53.0308 48.8488C53.004 48.9114 52.9909 48.979 52.9922 49.0472C52.9922 49.1476 53.0212 49.2459 53.0758 49.3302C53.1305 49.4145 53.2084 49.4812 53.3001 49.5222C53.6344 49.664 53.9796 49.7788 54.3322 49.8657C54.6924 49.9542 55.062 49.9986 55.4329 49.9979C55.7857 49.9992 56.1366 49.9457 56.4729 49.8393C56.7904 49.7404 57.0859 49.5816 57.3436 49.3714C57.5956 49.1619 57.7997 48.9008 57.9422 48.6057C58.0983 48.2745 58.1758 47.9118 58.1686 47.5457C58.1746 47.2386 58.122 46.9332 58.0137 46.6457C57.9174 46.3992 57.7776 46.172 57.6008 45.975",
    fill: "#003155"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8265 44.0721C63.6049 43.8494 63.3389 43.6759 63.0457 43.5629C62.3981 43.3235 61.6862 43.3235 61.0386 43.5629C60.7457 43.6759 60.4799 43.8495 60.2586 44.0721C60.0409 44.2979 59.8709 44.5651 59.7586 44.8579C59.6362 45.1781 59.5754 45.5186 59.5793 45.8614V47.5229C59.5754 47.8657 59.6362 48.2062 59.7586 48.5264C59.8711 48.8191 60.041 49.0863 60.2586 49.3121C60.4799 49.5349 60.7457 49.7084 61.0386 49.8214C61.6863 50.0605 62.398 50.0605 63.0457 49.8214C63.3389 49.7085 63.605 49.535 63.8265 49.3121C64.0439 49.0862 64.2138 48.8191 64.3264 48.5264C64.449 48.2062 64.5099 47.8657 64.5057 47.5229V45.8607C64.5099 45.5179 64.449 45.1773 64.3264 44.8571C64.2139 44.5645 64.0439 44.2973 63.8265 44.0714M63.4693 45.7986V47.5843C63.4809 47.7768 63.4542 47.9697 63.3907 48.1518C63.3271 48.3338 63.2281 48.5015 63.0993 48.645C62.8018 48.8879 62.4295 49.0206 62.0454 49.0206C61.6613 49.0206 61.2889 48.8879 60.9914 48.645C60.8625 48.5016 60.7634 48.3339 60.6999 48.1518C60.6364 47.9697 60.6098 47.7768 60.6215 47.5843V45.7986C60.6098 45.6061 60.6365 45.4132 60.7001 45.2311C60.7636 45.049 60.8626 44.8814 60.9914 44.7379C61.2889 44.4949 61.6613 44.3623 62.0454 44.3623C62.4295 44.3623 62.8018 44.4949 63.0993 44.7379C63.2281 44.8814 63.3271 45.0491 63.3906 45.2312C63.4541 45.4132 63.4809 45.6061 63.4693 45.7986Z",
    fill: "#003155"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0644 41.075C66.015 41.1224 65.9759 41.1795 65.9495 41.2426C65.9231 41.3058 65.9099 41.3737 65.9108 41.4422V49.4793C65.9116 49.6172 65.9666 49.7492 66.0641 49.8467C66.1616 49.9442 66.2936 49.9993 66.4315 50C66.5695 49.9998 66.7019 49.9449 66.7995 49.8473C66.8971 49.7497 66.952 49.6173 66.9522 49.4793V41.4422C66.9531 41.3739 66.94 41.3061 66.9139 41.2429C66.8877 41.1798 66.849 41.1227 66.8001 41.075C66.7519 41.0267 66.6946 40.9884 66.6315 40.9622C66.5684 40.9361 66.5008 40.9226 66.4326 40.9226C66.3643 40.9226 66.2967 40.9361 66.2336 40.9622C66.1706 40.9884 66.1126 41.0267 66.0644 41.075Z",
    fill: "#003155"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1665 43.5357C72.1172 43.5833 72.0782 43.6405 72.0519 43.7038C72.0256 43.7671 72.0126 43.8351 72.0137 43.9036V48.8365C71.5906 48.9581 71.1525 49.0199 70.7123 49.02C70.5354 49.0374 70.3569 49.0155 70.1895 48.9556C70.0222 48.8958 69.8702 48.7996 69.7446 48.674C69.6189 48.5483 69.5226 48.3964 69.4627 48.2291C69.4027 48.0618 69.3806 47.8833 69.398 47.7065V43.9036C69.3988 43.8352 69.3857 43.7673 69.3596 43.7041C69.3334 43.6408 69.2947 43.5836 69.2458 43.5357C69.1482 43.4383 69.0159 43.3836 68.878 43.3836C68.74 43.3836 68.6077 43.4383 68.5101 43.5357C68.4608 43.5834 68.4218 43.6406 68.3954 43.7038C68.369 43.7671 68.3557 43.8351 68.3565 43.9036V47.645C68.3321 47.9608 68.3763 48.2781 68.4861 48.5752C68.5959 48.8723 68.7687 49.1421 68.9927 49.366C69.2166 49.59 69.4864 49.7628 69.7835 49.8726C70.0806 49.9824 70.3979 50.0266 70.7137 50.0022C71.037 50.0022 71.3599 49.975 71.6787 49.9207C71.9936 49.867 72.304 49.7894 72.6072 49.6886C72.7391 49.6421 72.8532 49.5557 72.9338 49.4414C73.0143 49.3271 73.0572 49.1906 73.0565 49.0507V43.9079C73.0575 43.8393 73.0444 43.7713 73.018 43.708C72.9916 43.6447 72.9524 43.5875 72.9029 43.54C72.8547 43.4917 72.7975 43.4534 72.7344 43.4272C72.6713 43.4011 72.6037 43.3876 72.5355 43.3876C72.4672 43.3876 72.3996 43.4011 72.3365 43.4272C72.2735 43.4534 72.2162 43.4917 72.168 43.54",
    fill: "#003155"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8142 44.5107C76.9469 44.5132 77.0752 44.4635 77.1714 44.3722C77.22 44.3265 77.2583 44.2711 77.284 44.2095C77.3096 44.1479 77.3218 44.0817 77.32 44.015C77.3211 43.948 77.3088 43.8814 77.2837 43.8192C77.2586 43.757 77.2213 43.7005 77.1739 43.6531C77.1265 43.6056 77.07 43.5682 77.0079 43.543C76.9458 43.5178 76.8792 43.5054 76.8121 43.5064H75.4978V41.4429C75.4985 41.3745 75.4854 41.3067 75.4591 41.2436C75.4328 41.1805 75.394 41.1234 75.345 41.0757C75.2968 41.0274 75.2395 40.9891 75.1764 40.9629C75.1133 40.9368 75.0457 40.9233 74.9775 40.9233C74.9092 40.9233 74.8416 40.9368 74.7785 40.9629C74.7155 40.9891 74.6582 41.0274 74.61 41.0757C74.5607 41.1232 74.5218 41.1803 74.4955 41.2435C74.4692 41.3066 74.4561 41.3745 74.4571 41.4429V48.2129C74.4549 48.4602 74.5012 48.7056 74.5936 48.935C74.678 49.1472 74.8024 49.3411 74.96 49.5064C75.1148 49.6648 75.3002 49.79 75.505 49.8743C75.7165 49.9616 75.9433 50.006 76.1721 50.005C76.2926 50.0049 76.413 49.9987 76.5328 49.9864C76.6533 49.9741 76.7724 49.9595 76.89 49.9429C77.015 49.9266 77.1287 49.8623 77.2071 49.7636C77.2816 49.6706 77.3217 49.5548 77.3207 49.4357C77.3235 49.3655 77.3098 49.2956 77.2808 49.2316C77.2518 49.1676 77.2082 49.1113 77.1536 49.0672C77.0622 48.9878 76.946 48.9428 76.825 48.94C76.7179 48.9427 76.6111 48.9511 76.505 48.965C76.3946 48.9792 76.2834 48.9871 76.1721 48.9886C76.0835 48.9902 75.9955 48.9734 75.9136 48.9394C75.8317 48.9053 75.7578 48.8547 75.6964 48.7907C75.6276 48.7176 75.5746 48.6311 75.5405 48.5366C75.5065 48.4421 75.4922 48.3417 75.4985 48.2414V44.5157L76.8142 44.5107Z",
    fill: "#003155"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4158 40.9215C79.3293 40.9206 79.2436 40.937 79.1636 40.9697C79.0835 41.0024 79.0108 41.0507 78.9497 41.1118C78.8886 41.1729 78.8402 41.2456 78.8076 41.3257C78.7749 41.4057 78.7585 41.4914 78.7593 41.5779C78.7582 41.665 78.7743 41.7514 78.8068 41.8322C78.8393 41.913 78.8875 41.9866 78.9486 42.0486C79.0093 42.1111 79.082 42.1607 79.1622 42.1946C79.2425 42.2285 79.3287 42.246 79.4158 42.246C79.5029 42.246 79.5891 42.2285 79.6693 42.1946C79.7496 42.1607 79.8222 42.1111 79.8829 42.0486C79.9441 41.9866 79.9924 41.9131 80.0249 41.8323C80.0574 41.7515 80.0735 41.665 80.0722 41.5779C80.0733 41.4914 80.057 41.4056 80.0244 41.3254C79.9918 41.2453 79.9435 41.1725 79.8823 41.1114C79.8211 41.0502 79.7483 41.0019 79.6682 40.9693C79.5881 40.9367 79.5023 40.9204 79.4158 40.9215Z",
    fill: "#003155"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0479 43.5357C78.9986 43.5833 78.9596 43.6405 78.9333 43.7038C78.907 43.7671 78.894 43.8351 78.8951 43.9036V49.4793C78.9001 49.614 78.9571 49.7415 79.0541 49.835C79.1512 49.9285 79.2807 49.9808 79.4155 49.9808C79.5502 49.9808 79.6797 49.9285 79.7768 49.835C79.8738 49.7415 79.9308 49.614 79.9358 49.4793V43.9036C79.9369 43.8351 79.9239 43.7671 79.8976 43.7038C79.8713 43.6405 79.8323 43.5833 79.7829 43.5357C79.7347 43.4874 79.6774 43.4491 79.6144 43.423C79.5513 43.3968 79.4837 43.3833 79.4155 43.3833C79.3472 43.3833 79.2796 43.3968 79.2165 43.423C79.1535 43.4491 79.0962 43.4874 79.0479 43.5357Z",
    fill: "#003155"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7179 44.0721C85.4966 43.8494 85.2308 43.6759 84.9379 43.5629C84.29 43.3234 83.5779 43.3234 82.93 43.5629C82.6371 43.6758 82.3713 43.8493 82.15 44.0721C81.9323 44.2978 81.7623 44.5651 81.65 44.8579C81.5276 45.1781 81.4668 45.5186 81.4708 45.8614V47.5229C81.4669 47.8657 81.5277 48.2062 81.65 48.5264C81.7625 48.8191 81.9325 49.0863 82.15 49.3121C82.3713 49.5349 82.6371 49.7084 82.93 49.8214C83.5779 50.0606 84.29 50.0606 84.9379 49.8214C85.2309 49.7085 85.4967 49.5349 85.7179 49.3121C85.9353 49.0862 86.1053 48.8191 86.2179 48.5264C86.3405 48.2062 86.4013 47.8657 86.3972 47.5229V45.8607C86.4013 45.5179 86.3405 45.1773 86.2179 44.8571C86.1055 44.5644 85.9354 44.2972 85.7179 44.0714M85.3607 45.7986V47.5843C85.3724 47.7769 85.3457 47.9698 85.2821 48.1519C85.2184 48.334 85.1191 48.5016 84.99 48.645C84.6927 48.888 84.3205 49.0207 83.9365 49.0207C83.5525 49.0207 83.1802 48.888 82.8829 48.645C82.7538 48.5016 82.6546 48.334 82.591 48.1519C82.5273 47.9698 82.5005 47.7769 82.5122 47.5843V45.7986C82.5006 45.606 82.5274 45.4131 82.5911 45.231C82.6547 45.0489 82.7539 44.8813 82.8829 44.7379C83.1802 44.4949 83.5525 44.3621 83.9365 44.3621C84.3205 44.3621 84.6927 44.4949 84.99 44.7379C85.1191 44.8813 85.2183 45.0489 85.2819 45.231C85.3456 45.4131 85.3724 45.606 85.3607 45.7986Z",
    fill: "#003155"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8458 44.0407C91.6335 43.8312 91.3811 43.6667 91.1036 43.5572C90.7991 43.4386 90.4747 43.3797 90.1479 43.3836C89.5037 43.3775 88.8634 43.4839 88.2558 43.6979C88.1236 43.7443 88.0083 43.8294 87.9251 43.9421C87.8389 44.0552 87.7927 44.1936 87.7936 44.3357V49.4786C87.7928 49.5471 87.806 49.615 87.8322 49.6782C87.8585 49.7415 87.8974 49.7987 87.9465 49.8465C87.9948 49.8948 88.0521 49.9331 88.1152 49.9593C88.1783 49.9854 88.246 49.9989 88.3143 49.9989C88.3827 49.9989 88.4503 49.9854 88.5134 49.9593C88.5766 49.9331 88.6339 49.8948 88.6822 49.8465C88.731 49.7985 88.7697 49.7413 88.7958 49.678C88.822 49.6148 88.8351 49.547 88.8343 49.4786V44.5464C89.2615 44.4244 89.7036 44.3626 90.1479 44.3629C90.3232 44.3521 90.4988 44.3772 90.6641 44.4365C90.8294 44.4958 90.9809 44.5881 91.1093 44.7079C91.2275 44.8387 91.3184 44.9917 91.3767 45.158C91.4351 45.3243 91.4598 45.5005 91.4493 45.6764V49.4793C91.4493 49.6174 91.5042 49.7498 91.6019 49.8475C91.6995 49.9452 91.8319 50 91.97 50C92.1081 50 92.2406 49.9452 92.3382 49.8475C92.4359 49.7498 92.4907 49.6174 92.4907 49.4793V45.7379C92.4945 45.4122 92.4381 45.0887 92.3243 44.7836C92.2179 44.5056 92.0549 44.2526 91.8458 44.0407Z",
    fill: "#003155"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5701 47.0214C97.3237 46.7177 97.0017 46.4842 96.6365 46.3443L95.4801 45.8764C95.3379 45.814 95.209 45.725 95.1001 45.6143C95.0389 45.5486 94.992 45.471 94.9623 45.3863C94.9327 45.3016 94.921 45.2116 94.9279 45.1222C94.9234 45.0075 94.9492 44.8937 95.0026 44.7921C95.056 44.6906 95.1352 44.6049 95.2322 44.5436C95.3277 44.4829 95.432 44.4374 95.5415 44.4086C95.6533 44.3785 95.7685 44.3631 95.8843 44.3629C96.3118 44.358 96.735 44.4477 97.1236 44.6257C97.2151 44.6692 97.3174 44.6845 97.4176 44.6694C97.5177 44.6544 97.6111 44.6098 97.6858 44.5414C97.7376 44.4979 97.7789 44.4431 97.8064 44.3812C97.8338 44.3193 97.8468 44.252 97.8443 44.1843C97.8465 44.0801 97.8171 43.9776 97.7598 43.8905C97.7025 43.8034 97.6202 43.7357 97.5236 43.6964C97.2973 43.6013 97.0634 43.5253 96.8244 43.4693C96.283 43.3388 95.7172 43.3501 95.1815 43.5021C94.9386 43.5782 94.7123 43.6994 94.5144 43.8593C94.325 44.013 94.1693 44.2041 94.0572 44.4207C93.9197 44.7115 93.8633 45.0341 93.894 45.3543C93.9246 45.6746 94.0413 45.9806 94.2315 46.24C94.4473 46.4869 94.7158 46.6822 95.0172 46.8114L96.1715 47.2907C96.3793 47.3718 96.5669 47.4971 96.7215 47.6579C96.8408 47.8149 96.8996 48.0096 96.8872 48.2064C96.8925 48.321 96.8686 48.4351 96.8178 48.5379C96.7669 48.6407 96.6908 48.7289 96.5965 48.7943C96.392 48.9415 96.1455 49.0189 95.8936 49.015C95.6679 49.0163 95.443 48.9885 95.2244 48.9321C95.0179 48.8781 94.8164 48.8064 94.6222 48.7179C94.5899 48.7013 94.5565 48.6869 94.5222 48.675C94.4839 48.6629 94.4438 48.6571 94.4036 48.6579C94.2664 48.6533 94.1329 48.7031 94.0322 48.7964C93.9836 48.8421 93.9452 48.8975 93.9196 48.9591C93.894 49.0206 93.8817 49.0869 93.8836 49.1536C93.8793 49.2542 93.9061 49.3537 93.9604 49.4384C94.0148 49.5232 94.094 49.5891 94.1872 49.6271C94.4338 49.746 94.6927 49.8373 94.9593 49.8993C95.2537 49.9653 95.5548 49.9972 95.8565 49.9943C96.1364 49.9961 96.4143 49.9458 96.6758 49.8457C96.9195 49.7525 97.1432 49.6139 97.335 49.4371C97.5207 49.2652 97.6692 49.0571 97.7715 48.8257C97.8766 48.588 97.9299 48.3306 97.9279 48.0707C97.9339 47.6878 97.8064 47.3148 97.5672 47.0157",
    fill: "#003155"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 10,
    width: 9,
    height: 6
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4258 11.8107C19.045 12.1587 18.6973 12.5413 18.3872 12.9536C19.5628 13.5131 20.6178 14.2968 21.4929 15.2607C22.3155 14.7094 23.251 14.3489 24.2308 14.2057C25.0522 14.087 25.8892 14.1408 26.6886 14.3636C25.7344 12.5314 24.3522 11.04 22.3915 10.5257C21.2934 10.6349 20.2568 11.0844 19.4265 11.8114M22.3915 10.5257H22.413C22.4058 10.525 22.3986 10.525 22.3915 10.5257Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6459 6.37385L16.0194 12.8307L22.4304 19.4102L29.057 12.9533L22.6459 6.37385Z",
    fill: "url(#paint0_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 24,
    width: 6,
    height: 13
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2308 24.105C13.8106 24.1778 13.4149 24.3529 13.0786 24.615C12.9464 24.7123 12.8224 24.8203 12.7079 24.9379C12.9586 25.355 13.2022 25.7764 13.4336 26.21C13.8861 27.0167 14.265 27.8625 14.5658 28.7372C14.7795 29.3635 14.9548 30.0023 15.0907 30.65C15.1479 30.9179 15.2143 31.1822 15.2607 31.4522C15.5449 33.0955 15.583 34.7719 15.3736 36.4265C15.7313 36.5909 16.1053 36.7175 16.4893 36.8043C16.7896 35.8956 17.0348 34.9696 17.2236 34.0314C17.2993 33.6807 17.3572 33.3171 17.4143 32.9636C17.445 32.8029 17.4772 32.6486 17.5015 32.4879C17.5786 31.9798 17.6426 31.4714 17.6936 30.9629C17.8736 29.0693 17.8064 26.9986 16.7764 25.2779C16.6786 25.115 16.5622 24.9636 16.4507 24.8093C16.4957 24.8864 16.5486 24.9564 16.5936 25.0393C16.3702 24.7341 16.077 24.4868 15.7385 24.318C15.4 24.1493 15.0261 24.064 14.6479 24.0693C14.5074 24.0693 14.3672 24.081 14.2286 24.1043",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7803 23.4588L11.2064 36.6229L17.8016 37.4114L19.3755 24.2473L12.7803 23.4588Z",
    fill: "url(#paint1_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 12,
    width: 15,
    height: 27
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5022 13.0507C13.155 13.2486 12.8261 13.4769 12.5193 13.7329C11.8187 14.3338 11.2559 15.0788 10.8695 15.917C10.483 16.7552 10.282 17.667 10.28 18.59C10.278 18.9049 10.2986 19.2195 10.3415 19.5314C10.2508 17.6979 11.2922 15.85 13.1986 15.9022C13.5572 15.9169 13.9131 15.9705 14.2601 16.0622C15.0983 16.2913 15.8806 16.69 16.5586 17.2336C16.7015 17.3472 16.8515 17.47 16.9872 17.5993C17.2847 17.8572 17.5638 18.1358 17.8222 18.4329C18.0837 18.7341 18.3243 19.053 18.5422 19.3872C18.5608 19.415 18.575 19.4429 18.5936 19.4736C19.1297 20.315 19.5828 21.2066 19.9465 22.1357C21.1265 25.175 21.8557 29.5493 20.7493 32.5572C20.0943 34.2779 18.9786 35.7852 17.5243 36.9143C17.4307 36.9857 17.3472 37.0722 17.2522 37.1415C17.2622 37.405 17.2822 37.7007 17.3165 38.0214C17.5408 37.9029 17.7529 37.77 17.9643 37.6372C18.322 37.4149 18.6668 37.1726 18.9972 36.9114C19.0457 36.8736 19.0893 36.83 19.14 36.79C19.2115 36.7307 19.2765 36.67 19.3443 36.6122C19.4708 36.5022 19.5986 36.3979 19.7158 36.2864C22.1682 33.919 23.8662 30.8796 24.5964 27.55C25.2779 24.2606 24.8096 20.837 23.27 17.8514C22.7789 16.9219 22.168 16.0607 21.4529 15.29C20.5777 14.3261 19.5227 13.5424 18.3472 12.9829C18.2322 12.9279 18.1179 12.865 17.9986 12.8164C17.7142 12.7199 17.4229 12.6449 17.1272 12.5922C16.7159 12.4995 16.2959 12.4516 15.8743 12.4493C15.0447 12.4421 14.2273 12.6488 13.5007 13.0493",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.755 9.77074L5.68213 13.295L10.7459 40.6997L29.8188 37.1754L24.755 9.77074Z",
    fill: "url(#paint2_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 19,
    width: 15,
    height: 20
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49927 21.8986C2.32963 23.7744 1.95225 26.0377 2.44999 28.1915C3.19927 31.4579 5.63996 34.4722 8.45354 36.3343C8.75711 36.535 9.06929 36.7243 9.38214 36.9057C10.8945 37.7983 12.5861 38.3438 14.335 38.5029C14.8347 38.5282 15.3354 38.527 15.835 38.4993C15.9507 38.2265 16.0728 37.9279 16.1814 37.6557C16.29 37.3836 16.39 37.09 16.4886 36.8036C16.1045 36.7169 15.7306 36.5902 15.3728 36.4257C15.191 36.3517 15.0136 36.2672 14.8414 36.1729C14.4807 35.963 14.1417 35.718 13.8293 35.4415C12.8536 34.5748 12.1147 33.4741 11.6821 32.2429C10.9593 30.2379 11.048 28.0299 11.9293 26.0893C12.0499 25.8484 12.1859 25.6156 12.3364 25.3922C12.4472 25.2308 12.5715 25.0791 12.7078 24.9386C12.8224 24.821 12.9464 24.713 13.0786 24.6157C13.4149 24.3536 13.8106 24.1785 14.2307 24.1057C14.6729 24.0253 15.1288 24.0702 15.5467 24.2354C15.9647 24.4007 16.3281 24.6796 16.5957 25.0407C16.5493 24.9579 16.4957 24.8879 16.4528 24.8107C16.2169 24.4071 15.934 24.0328 15.61 23.6957C14.784 22.7413 13.8469 21.8891 12.8186 21.1572C12.0226 20.634 11.1523 20.2338 10.2371 19.97C9.51803 19.7575 8.77266 19.6472 8.02285 19.6422C7.14038 19.6121 6.26438 19.8032 5.47467 20.1982C4.68496 20.5931 4.00661 21.1794 3.50141 21.9036",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9072 12.8168L-6.82996 25.71L6.68813 45.3554L25.4253 32.4622L11.9072 12.8168Z",
    fill: "url(#paint3_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15,
    width: 6,
    height: 7
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M10.595 17.8136C10.5736 17.8771 10.5522 17.9429 10.5322 18.0064C10.5253 18.0256 10.5196 18.0452 10.515 18.065C10.3801 18.5362 10.3215 19.026 10.3415 19.5157C10.3308 19.4407 10.325 19.365 10.3186 19.2871C10.33 19.5207 10.3472 19.755 10.3743 19.9843C11.2381 20.2477 12.0602 20.6325 12.8158 21.1271C12.9293 21.2029 13.0401 21.28 13.1465 21.3579C13.3202 19.5327 14.0604 17.8076 15.2636 16.4243C14.9413 16.2669 14.6045 16.1411 14.2579 16.0486C13.9109 15.957 13.555 15.9033 13.1965 15.8886H13.1165C12.5456 15.9 11.9933 16.0932 11.5397 16.44C11.0861 16.7868 10.755 17.2692 10.5944 17.8171",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7643 14.4712L8.75366 20.865L14.8197 22.7726L16.8304 16.3787L10.7643 14.4712Z",
    fill: "url(#paint4_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 10,
    width: 18,
    height: 29
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4108 10.5465C22.4037 10.5457 22.3965 10.5457 22.3894 10.5465C24.3472 11.06 25.7329 12.5536 26.6865 14.3858C27.0444 15.0753 27.3515 15.79 27.6051 16.5243C28.4124 18.8868 28.689 21.3982 28.4152 23.8797C28.1413 26.3612 27.3238 28.7519 26.0208 30.8815C25.7679 31.2822 25.503 31.6672 25.2165 32.0429C25.0108 32.3358 24.783 32.6079 24.558 32.88C24.5201 32.925 24.4822 32.9786 24.4458 33.0229C24.1601 33.3522 23.8558 33.6658 23.5387 33.9672C22.8318 34.6234 22.0563 35.2018 21.2258 35.6922C21.2179 35.6922 21.2115 35.7007 21.2008 35.705C20.1352 36.4583 18.869 36.8766 17.5644 36.9065C17.2153 36.8948 16.8678 36.8533 16.5258 36.7822C16.3634 37.0508 16.2202 37.3305 16.0972 37.6193C15.9879 37.8951 15.9114 38.1828 15.8694 38.4765C16.0715 38.4586 16.8229 38.405 17.0236 38.3708C17.7422 38.2572 18.4522 38.1093 19.1437 37.9315C21.4458 37.3141 23.565 36.1504 25.3215 34.5393C25.6222 34.2843 25.9108 34.015 26.1958 33.7429C26.2186 33.7193 26.2472 33.695 26.2715 33.6715C26.3194 33.625 26.368 33.5858 26.4144 33.5429C28.5209 31.5444 30.1251 29.0762 31.0962 26.3396C32.0673 23.6031 32.3778 20.6758 32.0022 17.7965C31.866 17.0927 31.6676 16.4023 31.4094 15.7336C31.1515 15.122 30.8275 14.5404 30.443 13.9993C30.0293 13.4178 29.5518 12.8845 29.0194 12.4093C28.6737 12.1046 28.301 11.8321 27.9058 11.595C27.5098 11.3622 27.091 11.1707 26.6558 11.0236C26.3039 10.8837 25.9428 10.768 25.5751 10.6772C25.0402 10.5433 24.4931 10.4641 23.9422 10.4407C23.8399 10.4346 23.7375 10.4317 23.6351 10.4322C23.2225 10.4365 22.8109 10.474 22.4044 10.5443",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0112 2.75453L3.19299 18.4679L20.7356 46.1754L45.5539 30.4621L28.0112 2.75453Z",
    fill: "url(#paint5_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 11,
    width: 3,
    height: 2
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95935 12.3371C5.29275 12.3898 5.60884 12.5211 5.8815 12.72L6.45933 11.9236C6.07752 11.5852 5.63223 11.3261 5.14934 11.1614L4.95935 12.3371Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.01876 10.4782L4.24939 11.6186L5.399 13.4023L7.16838 12.262L6.01876 10.4782Z",
    fill: "url(#paint6_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 10,
    width: 3,
    height: 3
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M3.06431 11.0543C3.01289 11.0636 2.96361 11.0771 2.91504 11.0907L3.65077 12.5443C3.80948 12.4636 3.97733 12.4024 4.15074 12.3621C4.30544 12.3273 4.46361 12.31 4.62219 12.3107V11.025C4.39 10.9812 4.15419 10.9592 3.91789 10.9593C3.63089 10.9594 3.34483 10.9917 3.06505 11.0557",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.12075 10.1811L2.19287 11.4236L3.416 13.3214L5.34388 12.079L4.12075 10.1811Z",
    fill: "url(#paint7_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 13,
    width: 2,
    height: 3
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73719 14.1286C6.78956 14.4615 6.76191 14.8021 6.65649 15.1221L7.70578 15.4614C7.7889 14.971 7.77629 14.4692 7.66863 13.9836L6.73719 14.1286Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.45462 13.4692L5.98364 14.4172L6.98776 15.9752L8.45874 15.0272L7.45462 13.4692Z",
    fill: "url(#paint8_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 2
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13928 12.9429C6.37768 13.181 6.55658 13.472 6.66144 13.7922L7.53215 13.5064C7.37246 13.0525 7.12704 12.6335 6.80927 12.2722L6.13928 12.9429Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.1246 11.6406L5.44861 12.7207L6.54848 14.4274L8.22447 13.3472L7.1246 11.6406Z",
    fill: "url(#paint9_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 4,
    height: 3
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0.826486 12.5121L2.71365 13.4793C2.86629 13.1801 3.08633 12.9204 3.35648 12.7207L2.32363 11.3014C1.72832 11.5717 1.21195 11.9897 0.823608 12.5157",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.61673 10.148L-0.164917 11.9407L1.57014 14.6329L4.35179 12.8402L2.61673 10.148Z",
    fill: "url(#paint10_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 16,
    width: 3,
    height: 3
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09714 16.5522C4.94076 16.5854 4.78134 16.6022 4.62146 16.6022V18.5943C4.6686 18.5843 4.71643 18.5772 4.76428 18.5664C5.33325 18.4377 5.8655 18.1812 6.32072 17.8164L5.58573 16.3722C5.42912 16.4508 5.26397 16.5112 5.09357 16.5522",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.82302 15.5981L3.60999 17.0243L5.121 19.3689L7.33404 17.9427L5.82302 15.5981Z",
    fill: "url(#paint11_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 15,
    width: 3,
    height: 3
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88074 16.1943L6.7586 17.4014C7.13159 16.9896 7.41174 16.5024 7.58004 15.9729L6.52719 15.4357C6.37562 15.7347 6.15529 15.9934 5.88431 16.1907",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.08137 14.6654L4.98718 16.015L6.37941 18.1752L8.4736 16.8256L7.08137 14.6654Z",
    fill: "url(#paint12_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 16,
    width: 4,
    height: 3
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1.95935 18.1257C2.5616 18.4801 3.24848 18.6649 3.94722 18.6607L4.28078 16.575C3.94922 16.5208 3.63506 16.3894 3.36364 16.1914L1.95935 18.1257Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.60098 15.1339L0.832886 16.9179L2.64123 19.7238L5.40932 17.9399L3.60098 15.1339Z",
    fill: "url(#paint13_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 13,
    width: 3,
    height: 3
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0850395 15.1686L2.51005 14.7893C2.45728 14.4576 2.48346 14.1182 2.58648 13.7986L0.466466 13.1079C0.150258 13.7462 0.0181784 14.4601 0.0850395 15.1693",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.83277 11.9376L-0.920654 13.7122L0.771456 16.3377L3.52488 14.5632L1.83277 11.9376Z",
    fill: "url(#paint14_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 15,
    width: 4,
    height: 3
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0.223633 15.8914C0.426951 16.591 0.826259 17.2179 1.37436 17.6978L3.1072 15.9714C2.86941 15.7334 2.69102 15.4427 2.58648 15.1229L0.223633 15.8914Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25978 13.8092L-0.949951 15.8778L1.06913 19.0107L4.27885 16.9421L2.25978 13.8092Z",
    fill: "url(#paint15_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 3,
    height: 2
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7958 10.0079C11.1636 10.3146 11.5836 10.5527 12.0357 10.7107L12.1979 9.70643C11.8688 9.65481 11.5572 9.52446 11.2893 9.32645L10.7958 10.0079Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7076 8.65796L10.1357 9.81073L11.2864 11.3797L12.8583 10.227L11.7076 8.65796Z",
    fill: "url(#paint16_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 3,
    height: 2
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68787 8.52287C9.87558 8.94591 10.134 9.33384 10.4522 9.67L11.0343 9.09143C10.7987 8.85614 10.6225 8.56823 10.52 8.25143L9.68787 8.52287Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5624 7.60988L9.01147 8.74713L10.158 10.3108L11.709 9.17352L10.5624 7.60988Z",
    fill: "url(#paint17_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 8,
    width: 4,
    height: 3
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7786 9.33071L14.7607 10.6807C15.3769 10.4493 15.9268 10.0701 16.3621 9.57644L14.4207 8.58286C14.2669 8.87835 14.0469 9.13429 13.7778 9.33071",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4579 7.35094L12.7778 9.31644L14.6817 11.9124L17.3618 9.94695L15.4579 7.35094Z",
    fill: "url(#paint18_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 3,
    height: 2
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5337 9.73145V10.8472C12.725 10.8905 12.9194 10.9187 13.1151 10.9314C13.4692 10.9508 13.8244 10.9239 14.1715 10.8514L13.4887 9.50861C13.1924 9.65739 12.8652 9.73399 12.5337 9.73217",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5988 8.7262L11.8444 10.0129L13.1061 11.7334L14.8606 10.4467L13.5988 8.7262Z",
    fill: "url(#paint19_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 2,
    width: 4,
    height: 4
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2851 2.90215L12.8679 5.50144C13.1978 5.55419 13.5106 5.68416 13.7808 5.88073L15.495 3.51858C14.9242 3.15697 14.271 2.94587 13.5965 2.905C13.5394 2.905 13.4829 2.90143 13.4258 2.90143H13.2829",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5771 1.64702L11.4465 3.94284L13.7871 7.13443L16.9177 4.83861L14.5771 1.64702Z",
    fill: "url(#paint20_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 6,
    width: 2,
    height: 3
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35289 6.66928C9.3265 7.14284 9.38431 7.61734 9.52362 8.07071L10.4408 7.92785C10.387 7.59889 10.4142 7.26178 10.52 6.9457L9.36576 6.57071C9.36576 6.60285 9.35645 6.63643 9.35359 6.67072",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1009 6.0001L8.60864 7.0943L9.74167 8.63952L11.2339 7.54532L10.1009 6.0001Z",
    fill: "url(#paint21_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 6,
    width: 4,
    height: 3
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6293 7.27073C14.6526 7.42048 14.6598 7.57228 14.6507 7.72356C14.6402 7.90396 14.6058 8.08217 14.5486 8.25357L16.7864 8.98143C17.1236 8.42705 17.3198 7.79849 17.3579 7.15073C17.3636 7.04787 17.3614 6.94572 17.3614 6.84143L14.6293 7.27073Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3789 5.49997L13.5286 7.59L15.5329 10.3235L18.3833 8.23346L16.3789 5.49997Z",
    fill: "url(#paint22_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 4,
    width: 4,
    height: 3
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0365 6.09998C14.2717 6.3365 14.4481 6.62497 14.5515 6.94214L17.2722 6.05857C17.1027 5.27877 16.7049 4.5671 16.1294 4.01428L14.0365 6.09998Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1403 2.47156L12.64 5.03857L15.1682 8.4859L18.6685 5.91889L16.1403 2.47156Z",
    fill: "url(#paint23_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 2,
    width: 3,
    height: 4
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6715 3.93147L11.573 5.70789C11.8702 5.55622 12.1992 5.47737 12.533 5.47788V2.98788C11.8398 3.1318 11.1973 3.45746 10.6715 3.93147Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.881 2.10132L9.37439 3.93933L11.3213 6.59453L13.828 4.75652L11.881 2.10132Z",
    fill: "url(#paint24_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 3,
    height: 3
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45068 6.02002L10.645 6.63359C10.7978 6.33668 11.0179 6.07959 11.2878 5.88286L10.2221 4.41501C9.84818 4.88524 9.58545 5.43392 9.45352 6.02002",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6438 3.53991L8.39282 5.1907L10.0926 7.50851L12.3436 5.85771L10.6438 3.53991Z",
    fill: "url(#paint25_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 3,
    width: 2,
    height: 3
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5443 4.25431C21.5482 4.53078 21.5795 4.80619 21.6379 5.07645L22.5136 4.94076C22.4571 4.59214 22.4848 4.23506 22.5943 3.89932L21.5943 3.57217C21.558 3.7977 21.5408 4.02588 21.5429 4.25431",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4752 3.23775L21.0643 3.74289L21.6612 5.40998L23.0721 4.90484L22.4752 3.23775Z",
    fill: "url(#paint26_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 5,
    width: 3,
    height: 2
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7708 5.55002C21.9314 6.01506 22.1733 6.44795 22.485 6.8286L23.1422 6.1736C22.8928 5.92363 22.7052 5.61887 22.5943 5.2836L21.7708 5.55002Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9883 4.8518L21.2836 5.46216L21.9296 7.26643L23.6343 6.65608L22.9883 4.8518Z",
    fill: "url(#paint27_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 6,
    width: 3,
    height: 3
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7794 6.84144C24.7679 6.84144 24.7551 6.84144 24.7437 6.84144V8.25931C25.0917 8.34734 25.4497 8.38984 25.8087 8.38574C26.0806 8.38044 26.3513 8.34909 26.6172 8.29216L25.7601 6.5993C25.4566 6.75437 25.1216 6.83815 24.7808 6.84429",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3997 6.00205L24.1715 6.80002L24.9529 8.98179L27.181 8.18383L26.3997 6.00205Z",
    fill: "url(#paint28_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 6,
    width: 3,
    height: 3
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8329 7.21216C23.2206 7.585 23.6765 7.87965 24.1757 8.08001L24.3807 6.81C24.0323 6.75329 23.702 6.61556 23.4165 6.40787L22.8329 7.21216Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2029 5.9171L22.3021 6.59784L23.0084 8.56991L24.9092 7.88917L24.2029 5.9171Z",
    fill: "url(#paint29_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 3,
    width: 4,
    height: 4
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9686 4.2443C26.9861 4.34768 26.9954 4.45229 26.9964 4.55715C27.0002 4.80498 26.9625 5.05171 26.885 5.28715L29.4657 6.12643C29.7869 5.50939 29.9492 4.82199 29.9379 4.12643C29.9379 4.00929 29.925 3.89572 29.915 3.78143L26.9686 4.2443Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6008 2.81155L26.1415 4.05002L27.2328 7.0984L30.6921 5.85994L29.6008 2.81155Z",
    fill: "url(#paint30_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 5,
    width: 4,
    height: 4
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0644 6.41288L27.2787 8.08716C27.9661 7.81614 28.5699 7.36873 29.0294 6.79001L26.7437 5.61929C26.5818 5.93349 26.3484 6.20532 26.0623 6.41288",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6957 4.67766L25.2815 5.89999L26.4017 9.02908L29.816 7.80674L28.6957 4.67766Z",
    fill: "url(#paint31_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 0,
    width: 3,
    height: 3
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6793 0.000732422C25.6079 0.000732422 25.5429 0.0100103 25.4736 0.0150103L25.0972 2.37217C25.4467 2.42752 25.7781 2.56484 26.0643 2.77288L27.7171 0.496447C27.1085 0.17108 26.4288 0.00126637 25.7386 0.00214931H25.6793",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4189 -0.83125L24.2172 0.315002L25.394 3.60212L28.5957 2.45587L27.4189 -0.83125Z",
    fill: "url(#paint32_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 0,
    width: 4,
    height: 4
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3379 3.00289C26.5887 3.25287 26.7765 3.55891 26.8858 3.89575L29.7515 2.96718C29.5096 2.17655 29.0391 1.4752 28.3993 0.951477L26.3379 3.00289Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3639 -0.133737L25.403 1.28433L26.7259 4.97965L30.6869 3.56158L29.3639 -0.133737Z",
    fill: "url(#paint33_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 1,
    width: 3,
    height: 3
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7064 3.04358L22.7329 3.56788C22.8932 3.25287 23.126 2.98041 23.4121 2.77287L22.505 1.52573C22.1363 1.97043 21.8642 2.48713 21.7064 3.04286",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2186 0.985258L21.0586 1.75858L21.9003 4.10959L24.0603 3.33627L23.2186 0.985258Z",
    fill: "url(#paint34_linear_59_541)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_59_541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 0,
    width: 3,
    height: 3
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9479 1.06928L23.7179 2.58642C24.0232 2.42966 24.3604 2.34512 24.7036 2.33929H24.7358V0.125C24.0718 0.287394 23.4583 0.611539 22.9501 1.06856",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_59_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.533 -0.441991L22.1672 0.404999L23.1512 3.15345L25.517 2.30647L24.533 -0.441991Z",
    fill: "url(#paint35_linear_59_541)"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1729 12.76C77.1572 12.6686 76.6672 10.6622 73.1643 10.6622H61.6093C61.4586 10.6711 61.3116 10.7131 61.1789 10.7852C61.0462 10.8573 60.931 10.9577 60.8414 11.0793C60.7396 11.2121 60.6681 11.3656 60.632 11.529C60.596 11.6924 60.5963 11.8617 60.6329 12.025C60.9043 13.2393 61.98 14.105 64.2564 14.105H66.3993V37.7207C66.3924 37.9194 66.4631 38.113 66.5964 38.2605C66.7297 38.4079 66.9152 38.4977 67.1136 38.5107H70.4707C70.5718 38.5094 70.6716 38.4877 70.7641 38.4469C70.8565 38.4061 70.9398 38.3471 71.0089 38.2733C71.078 38.1995 71.1316 38.1126 71.1662 38.0176C71.2009 37.9227 71.216 37.8217 71.2108 37.7207V14.105H76.16C76.3098 14.1062 76.4577 14.0715 76.5913 14.0038C76.7249 13.936 76.8403 13.8373 76.9279 13.7157C77.0307 13.5809 77.1056 13.427 77.1483 13.2629C77.191 13.0988 77.2005 12.9278 77.1765 12.76",
    fill: "#003155"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9529 13.9436C96.3598 13.0296 95.5355 12.2888 94.5636 11.7964C93.688 11.3368 92.7391 11.0332 91.7593 10.8993C90.964 10.7781 90.1615 10.7094 89.3572 10.6936H80.8572C80.6542 10.7079 80.4647 10.8004 80.3285 10.9516C80.1924 11.1028 80.1202 11.3009 80.1272 11.5043V37.7186C80.1226 37.9193 80.1962 38.1138 80.3324 38.2612C80.4686 38.4087 80.6568 38.4973 80.8572 38.5086H84.2222C84.4233 38.4993 84.6127 38.4112 84.7493 38.2634C84.8859 38.1155 84.9588 37.9198 84.9522 37.7186V37.68C84.9522 37.5857 84.9879 37.495 84.9879 37.3857V31.9843H89.3565C90.161 31.973 90.9638 31.9045 91.7586 31.7793C92.7402 31.6542 93.6907 31.3504 94.5629 30.8829C95.6463 30.2705 96.5362 29.3664 97.1314 28.2734C97.7267 27.1804 98.0034 25.9424 97.93 24.7V17.8186C98.0042 16.4563 97.6632 15.1036 96.9522 13.9393M93.095 25.8736C93.1556 26.5122 93.0272 27.1545 92.7257 27.7207C92.4665 28.1365 92.1144 28.4866 91.6972 28.7436C91.2199 28.9805 90.7051 29.1325 90.1757 29.1929C89.6345 29.255 89.0905 29.2895 88.5457 29.2964H84.9922V13.1893H88.5436C88.9893 13.1893 89.5322 13.2272 90.1736 13.2857C90.7056 13.3515 91.2212 13.5136 91.695 13.7643C92.1229 14.0005 92.4785 14.3486 92.7236 14.7714C93.0241 15.3576 93.1522 16.0169 93.0929 16.6729L93.095 25.8736Z",
    fill: "#003155"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1757 15.7129C57.9681 14.7367 57.5125 13.8304 56.8529 13.0814C56.0699 12.2811 55.113 11.672 54.0565 11.3014C52.6076 10.8301 51.0879 10.614 49.565 10.6629H41.39C41.2877 10.6653 41.1868 10.6882 41.0934 10.7303C41.0001 10.7723 40.916 10.8326 40.8463 10.9077C40.7766 10.9827 40.7227 11.0709 40.6876 11.1671C40.6525 11.2633 40.6371 11.3656 40.6422 11.4679V37.7207C40.6383 37.8217 40.6545 37.9224 40.69 38.0171C40.7254 38.1117 40.7794 38.1983 40.8487 38.2718C40.9179 38.3454 41.0012 38.4044 41.0935 38.4454C41.1859 38.4864 41.2854 38.5086 41.3865 38.5107H49.5615C51.0845 38.5575 52.6041 38.34 54.0529 37.8679C55.1135 37.5084 56.0724 36.9 56.8493 36.0936C57.5095 35.3431 57.9651 34.435 58.1722 33.4572C58.3634 32.5914 58.4637 31.708 58.4715 30.8214V18.4007C58.465 17.4971 58.3647 16.5965 58.1722 15.7136M53.6079 32.1564C53.5998 32.5994 53.5662 33.0416 53.5072 33.4807C53.4452 33.8884 53.2926 34.2769 53.0607 34.6179C52.7755 35.0363 52.3834 35.3705 51.9251 35.5857C51.1824 35.9145 50.3724 36.0628 49.5615 36.0186L45.5179 35.9922V13.1936H49.5615C50.3784 13.1648 51.192 13.3109 51.9479 13.6222C52.3555 13.8202 52.7097 14.113 52.981 14.476C53.2523 14.839 53.4327 15.2616 53.5072 15.7086C53.5675 16.1586 53.6011 16.6118 53.6079 17.0657V32.1564Z",
    fill: "#003155"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_541",
    x1: -57.027,
    y1: 159.054,
    x2: -56.8414,
    y2: 158.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144,
    stopColor: "#012736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#043242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#0A4458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#125D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#135F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#156179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#498FAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_59_541",
    x1: 28.7367,
    y1: 184.913,
    x2: 28.7682,
    y2: 184.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#442A0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#835518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#A1691D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#A87226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#BE8C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#E0B765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9C16F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_59_541",
    x1: -127.217,
    y1: 89.5165,
    x2: -126.969,
    y2: 89.4707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#4A9333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#569930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#6BA32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#88B124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ADC41C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCC19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_59_541",
    x1: -92.0903,
    y1: 138.973,
    x2: -91.8841,
    y2: 138.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F67D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_59_541",
    x1: 9.49287,
    y1: 174.084,
    x2: 9.57128,
    y2: 173.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182C14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#1F3416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#324D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#50722B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#77994F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B569"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_59_541",
    x1: -91.3748,
    y1: 142.347,
    x2: -91.1514,
    y2: 142.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F67D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#F67D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#8A8766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#2792B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#0096D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#0088CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_59_541",
    x1: -86.6761,
    y1: 131.114,
    x2: -86.4567,
    y2: 130.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F67D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_59_541",
    x1: -86.8603,
    y1: 130.037,
    x2: -86.6406,
    y2: 129.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F67D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_59_541",
    x1: -87.9279,
    y1: 132.382,
    x2: -87.7087,
    y2: 132.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F67D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_59_541",
    x1: -87.1409,
    y1: 131.977,
    x2: -86.9214,
    y2: 131.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F67D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_59_541",
    x1: -87.4712,
    y1: 129.231,
    x2: -87.2515,
    y2: 129.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F67D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_59_541",
    x1: -89.7522,
    y1: 131.94,
    x2: -89.5331,
    y2: 131.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F67D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_59_541",
    x1: -88.9281,
    y1: 132.399,
    x2: -88.7082,
    y2: 132.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F67D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_59_541",
    x1: -90.082,
    y1: 130.66,
    x2: -89.8605,
    y2: 130.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F67D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_59_541",
    x1: -88.5629,
    y1: 129.085,
    x2: -88.3454,
    y2: 128.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F67D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_59_541",
    x1: -89.7101,
    y1: 129.639,
    x2: -89.4886,
    y2: 129.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F67D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_59_541",
    x1: -77.0562,
    y1: 139.514,
    x2: -76.8456,
    y2: 139.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#4A9333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#569930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#6BA32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#88B124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ADC41C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCC19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_59_541",
    x1: -76.6041,
    y1: 138.531,
    x2: -76.3947,
    y2: 138.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#4A9333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#569930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#6BA32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#88B124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ADC41C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCC19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_59_541",
    x1: -76.1278,
    y1: 141.55,
    x2: -75.9161,
    y2: 141.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#4A9333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#569930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#6BA32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#88B124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ADC41C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCC19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_59_541",
    x1: -76.8419,
    y1: 140.655,
    x2: -76.6314,
    y2: 140.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#4A9333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#569930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#6BA32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#88B124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ADC41C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCC19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_59_541",
    x1: -73.2043,
    y1: 140.003,
    x2: -72.9946,
    y2: 139.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#4A9333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#569930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#6BA32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#88B124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ADC41C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCC19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_59_541",
    x1: -75.7323,
    y1: 137.953,
    x2: -75.5219,
    y2: 137.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#4A9333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#569930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#6BA32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#88B124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ADC41C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCC19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_59_541",
    x1: -74.9106,
    y1: 141.647,
    x2: -74.6996,
    y2: 141.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#4A9333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#569930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#6BA32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#88B124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ADC41C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCC19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_59_541",
    x1: -73.5805,
    y1: 141.074,
    x2: -73.3705,
    y2: 140.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#4A9333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#569930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#6BA32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#88B124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ADC41C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCC19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_59_541",
    x1: -73.6701,
    y1: 138.379,
    x2: -73.4595,
    y2: 138.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#4A9333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#569930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#6BA32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#88B124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ADC41C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCC19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_59_541",
    x1: -74.6236,
    y1: 137.965,
    x2: -74.412,
    y2: 137.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#4A9333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#569930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#6BA32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#88B124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ADC41C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCC19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_59_541",
    x1: -107.745,
    y1: 112.107,
    x2: -107.499,
    y2: 112.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_59_541",
    x1: -108.298,
    y1: 112.351,
    x2: -108.051,
    y2: 112.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_59_541",
    x1: -108.477,
    y1: 113.468,
    x2: -108.23,
    y2: 113.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_59_541",
    x1: -108.514,
    y1: 112.761,
    x2: -108.269,
    y2: 112.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_59_541",
    x1: -107.558,
    y1: 114.284,
    x2: -107.313,
    y2: 114.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_59_541",
    x1: -108.246,
    y1: 114.091,
    x2: -108,
    y2: 114.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_59_541",
    x1: -106.467,
    y1: 113.39,
    x2: -106.22,
    y2: 113.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_59_541",
    x1: -106.722,
    y1: 114.006,
    x2: -106.476,
    y2: 113.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_59_541",
    x1: -107.109,
    y1: 112.171,
    x2: -106.863,
    y2: 112.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_59_541",
    x1: -106.604,
    y1: 112.537,
    x2: -106.358,
    y2: 112.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006CB7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97.8629,
    height: 50,
    fill: "white",
    transform: "translate(0.0686035)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1309e2be784c446251b4ddcb737af420.svg";
export { ForwardRef as ReactComponent };